import React from "react";
import PropTypes from 'prop-types';
import { getSelectionText } from "store/filters/filterUtils";

import { Dropdown } from "../../../blocks/Dropdown/Dropdown";

export const SortOptions = props => ( 
  <Dropdown {...props} 
    selectionText={getSelectionText(props)}
    onChange={o => props.onChange({
    key: props.filterKey, 
    value: o.value})
  } />
);

SortOptions.propTypes = {
  onChange: PropTypes.func.isRequired,
};